import { css } from "@emotion/react";
import { Typography } from "@mui/material";
import React, { ReactNode } from "react";
import styled from "@emotion/styled";
import { ToolTipInfo } from "./ToolTipInfo";

const centredCss = css`
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(2)};
  ${({ centred }: { centred: boolean }) => (centred ? centredCss : "")}
`;

const Title = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  gap: ${({ theme }) => theme.spacing(1)};
`;

interface Props {
  title?: string;
  toolTipDesc?: string;
  centred?: boolean;
  children: ReactNode;
}

export const Block = ({
  title,
  children,
  centred = false,
  toolTipDesc,
}: Props) => (
  <Container centred={centred}>
    {title && (
      <Title>
        <Typography color="textSecondary" variant="body3">
          {title}
        </Typography>
        {toolTipDesc && <ToolTipInfo desc1={toolTipDesc} />}
      </Title>
    )}
    {children}
  </Container>
);
